import React, { useEffect, useRef, useState } from "react";
// import Practitoner from "./practitoner";
// import Footer from "../../footer";
// import Search from "../../../../../components/search";
import "./practitoner/practitoner.css";
import "../practitonerInfo/practitonerinfo.css";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  setPaymentMethodAvailbale,
  setPaymentTypeAvailbale,
} from "../../../../../reducer/clientsSlice";
import { useOutsideAlerter } from "../../../../../utils/helpers";
import { ScrollController } from "@fullcalendar/core/internal";
import { getMediumServiceDetails } from "../../../../../services/client";
import { useLocation } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import GridLoader from "react-spinners/GridLoader";
import MediumCard from "../mediumcard";
import useProfessionalBooking from "../useProfessionalBooking";

// The availability filter keeps its English name in state (it is compared
// below); this maps it to its translation key for display only.
const AVAILABILITY_KEYS = {
  Today: "today",
  Tomorrow: "tomorrow",
  "This Week": "thisWeek",
  Any: "any",
};

export default function Practitioners({
  specialtyData = [],
  languages = [],
  practitioners = [],
  isListLoading = false,
  onClick,
  back,
  getPractitionarFiltersList,
  setBookInfo,
  startBookaSessionLaterVideo,
  startBookaSessionLaterQuestions,
  getSubsessions,
  setRenderType,
  onToggleFavorite = () => {},
  canFavorite = false,
  favoritePendingId = null,
  openingProfileId = null,
}) {
  const { t } = useTranslation("clientPremium");
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.user);
  const wrapperRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);


  const [languagesList, setlanguagesList] = useState([]);
  const [specialtyList, setspecialtyList] = useState([]);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [maxNoOfParticipantList, setMaxNoOfParticipantList] = useState([
    {
      id: 1,
      name: "1",
      status: false,
      label: "1",
      type: "maxNoOfParticipant",
    },
    {
      id: 2,
      name: "2",
      status: false,
      label: "2",
      type: "maxNoOfParticipant",
    },
  ]);
  const [currencyList, setCurrencyList] = useState([
    {
      id: 1,
      name: "AUD",
      status: false,
      label: "AUD",
      type: "currency",
    },
    {
      id: 2,
      name: "CAD",
      status: false,
      label: "CAD",
      type: "currency",
    },
    {
      id: 3,
      name: "USD",
      status: false,
      label: "USD",
      type: "currency",
    },
    {
      id: 4,
      name: "EUR",
      status: false,
      label: "EUR",
      type: "currency",
    },

    
  ]);
  const [sessionLengthList, setsessionLengthList] = useState([
    {
      id: 30,
      name: "30Minutes",
      status: false,
      label: "30 Minutes",
      type: "sessionlength",
    },
    {
      id: 45,
      name: "45Minutes",
      status: false,
      label: "45 Minutes",
      type: "sessionlength",
    },
    {
      id: 60,
      name: "60Minutes",
      status: false,
      label: "60 Minutes",
      type: "sessionlength",
    },
    {
      id: 452,
      name: "452Minutes",
      status: false,
      label: "45 Minutes for 2 People",
      type: "sessionlength",
    },
    {
      id: 602,
      name: "602Minutes",
      status: false,
      label: "60 Minutes for 2 People",
      type: "sessionlength",
    },
  ]);
  const [experienceList, setExperienceList] = useState([
    {
      id: 1,
      name: "1year",
      status: false,
      label: "1 year",
      type: "experience",
    },
    {
      id: 2,
      name: "2years",
      status: false,
      label: "2-3 years",
      type: "experience",
    },
    {
      id: 3,
      name: "3years",
      status: false,
      label: "3-5 years",
      type: "experience",
    },
    {
      id: 4,
      name: "4years",
      status: false,
      label: "5-10 years",
      type: "experience",
    },
    {
      id: 5,
      name: "5years",
      status: false,
      label: "10-15 years",
      type: "experience",
    },
    {
      id: 6,
      name: "6years",
      status: false,
      label: "15+ years",
      type: "experience",
    },
  ]);
  const [whereDoIPayList, setwhereDoIPayList] = useState([
    {
      id: 1,
      name: "PaytoBook",
      status: false,
      label: "Pay to Book",
      type: "whereDoI",
    },
    {
      id: 2,
      name: "PayAfterSession",
      status: false,
      label: "Pay After Session",
      type: "whereDoI",
    },
  ]);
  const [recording, setRecording] = useState("");
  const [favoritesOnly, setFavoritesOnly] = useState(false);
  const [availability, setAvailability] = useState("Any");
  const [currencyName, setCurrencyName] = useState("");
  const [selectedName, setSelectedName] = useState("");

  const [filterData, setFilterData] = useState({
    selectedName: "",
    languages: [],
    specialities: [],
    allow_REcording: "",
    availability:"",
    whereDoIPay: [],
    sessionLength: [],
    experience: [],
    session_currency: "",
    favorites_only: false,
  });
  const [displayData, setDisplayData] = useState({
    selectedName: "",
    languages: [],
    specialities: [],
    allow_REcording: "",
    availability:"",
    whereDoIPay: [],
    sessionLength: [],
    experience: [],
    session_currency: "",
    favorites_only: false,
  });
  const [offset, setOffset] = useState(0);

  const [filterTab, setFilterTab] = useState(true);

  // setProfessionalInfo / setMediumSessionInfo are used by the ?from=coach-reviews
  // resume path below, which seeds the modal directly rather than going through
  // getBookingLink.
  const { getBookingLink, setProfessionalInfo, setMediumSessionInfo, bookingModal } =
    useProfessionalBooking({
      getSubsessions,
      // This listing already lives inside the booking pages, so Continue just
      // moves the wizard on rather than navigating anywhere.
      onContinue: (info) => {
        setBookInfo({
          general: {
            personal_booking_link: info.personal_booking_link,
            payType: info.payType,
            pre_pay_session_type: info.pre_pay_session_type,
            post_pay_session_type: info.post_pay_session_type,
            medium_id: info.medium_id,
            ...info,
          },
        });
        setRenderType("newappointment");
      },
    });
  const filterTimerRef = useRef(null);

  // Every filter refresh goes through here so the loader is cleared only by the
  // request whose result is actually shown (an aborted/stale one returns false).
  const runFilter = async (info) => {
    setIsLoading(true);
    let applied = true;
    try {
      applied = await getPractitionarFiltersList(info);
    } finally {
      if (applied !== false) setIsLoading(false);
    }
  };

  useEffect(() => {
    let off = localStorage.getItem("offset");
    if (off !== undefined) {
      window.scrollTo({ top: off, left: 0, behavior: "smooth" });
    }

    const onScroll = () => setOffset(window.pageYOffset);
    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const updateLanguage = (value, checked) => {
    let list = languagesList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setlanguagesList(list);
  };

  const updateSpeciality = (value, checked) => {
    let list = specialtyList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setspecialtyList(list);
  };
  const updateSessionLength = (value, checked) => {
    let list = sessionLengthList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setsessionLengthList(list);
  };
  const updateExperience = (value, checked) => {
    let list = experienceList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setExperienceList(list);
  };
  const updatewhereDoIPay = (value, checked) => {
    let list = whereDoIPayList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setwhereDoIPayList(list);
  };
  const updateCurrency = (value, checked) => {
    let list = currencyList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setCurrencyList(list);
  };
  const updateMaxNoOfParticipant = (value, checked) => {
    let list = maxNoOfParticipantList.map((item) => {
      if (parseInt(item.id) === parseInt(value)) {
        return {
          ...item,
          ...(item.status = checked),
        };
      }
      return {
        ...item,
      };
    });
    setMaxNoOfParticipantList(list);
  };
  const deleteElement = async (item, type) => {
    let info = filterData;
    if (type === "language") {
      removeValue(info.languages, String(item.id));
      updateLanguage(item.id, false);
    }
    if (type === "sessionlength") {
      removeValue(info.sessionLength, item.id);
      updateSessionLength(item.id, false);
    }
    if (type === "experience") {
      removeValue(info.experience, String(item.id));
      updateExperience(item.id, false);
    }
    if (type === "wheredoipay") {
      removeValue(info.whereDoIPay, String(item.id));
      updatewhereDoIPay(item.id, false);
    } else {
      removeValue(info.specialities, String(item.id));
      updateSpeciality(item.id, false);
    }
    if (type === "currency") {
      removeValue(info.sessionLength, item.id);
      updateMaxNoOfParticipant(item.id, false);
    }
    setFilterData(info);
    clearTimeout(filterTimerRef.current);
    runFilter(info);
  };

  const deleteInfo = (type) => {
    let info = filterData;
    if (type === "rec") {
      info.allow_REcording = "";
    } else if (type === "fav") {
      info.favorites_only = false;
      setFavoritesOnly(false);
    } else if (type === "avail") {
      info.availability = "";
    } else if (type === "curren") {
      info.session_currency = "";
    } else {
      info.whereDoIPay = "";
    }
    setFilterData(info);
    clearTimeout(filterTimerRef.current);
    runFilter(info);
  };
  const changeHandler = (e, type) => {
    let checked = e.target.checked;
    let value = e.target.value;
    let name = e.target.name;
    clearTimeout(filterTimerRef.current);
    setIsLoading(true);


    let info = filterData;
    let display = displayData;

    if (type === "name") {
      if (value) {
        setSelectedName(value);
        info.selectedName = value.trim();
      } else {
        info.selectedName = "";
        setSelectedName("");
      }
    }
    if (type === "maxNoOfParticipant") {
      updateMaxNoOfParticipant(value, checked);
      sessionLengthList.map((item) => {
        updateSessionLength(item.id, false);
      });
      if (checked) {
        let lens = maxNoOfParticipantList.every((item) => item.status);
        if (maxNoOfParticipantList.every((item) => item.status)) {
          info.sessionLength = [];
          info.sessionLength.push(30, 45, 60, 452, 602);
        } else if (value == 1) {
          info.sessionLength = [];
          info.sessionLength.push(30, 45, 60);
        } else {
          info.sessionLength = [];
          info.sessionLength.push(452, 602);
        }
        display.sessionLength.push(name);
      } else {
        if (value == 1) {
          removeValue(info.sessionLength, 30);
          removeValue(info.sessionLength, 45);
          removeValue(info.sessionLength, 60);
        } else {
          removeValue(info.sessionLength, 452);
          removeValue(info.sessionLength, 602);
        }
        removeValue(info.sessionLength, value);
        // removeValue(display.sessionLength, name);
      }
    }
    if (type === "language") {
      updateLanguage(value, checked);
      if (checked) {
        info.languages.push(value);
        display.languages.push(name);
      } else {
        removeValue(info.languages, value);
        removeValue(display.languages, name);
      }
    }
    if (type === "specialty") {
      updateSpeciality(value, checked);
      if (checked) {
        info.specialities.push(value);
        display.specialities.push(name);
      } else {
        removeValue(info.specialities, value);
        removeValue(display.specialities, name);
      }
    }
    if (type === "Recording") {
      if (checked) {
        setRecording(name);
        info.allow_REcording = value;
      } else {
        info.allow_REcording = "";
        setRecording("");
      }
      // if (checked) {
      //   info.allow_REcording.push(value);
      //   display.allow_REcording.push(name);
      // } else {
      //   removeValue(info.allow_REcording, value);
      //   removeValue(display.allow_REcording, name);
      // }
    }
    if (type === "Favorites") {
      setFavoritesOnly(checked);
      info.favorites_only = checked;
    }
    if (type === "Availability") {
      if (checked) {
        if(name === "Any"){
          setAvailability(name);
          info.availability = "";
        }else{
          setAvailability(name);
          info.availability = value;
        }
      } else {
        info.availability = "";
        setAvailability("");
      }

    }
    if (type === "currency") {
      if (checked) {
        setCurrencyName(name);
        info.session_currency = name;
      } else {
        info.session_currency = "";
        setCurrencyName("");
      }
    }
    // if (type === "wheredoipay") {
    //   if (checked && name === "when_do_i_pay_1") {
    //     info.whereDoIPay = 1;
    //     setPayTime("Pay to Book");
    //   } else if (checked && name === "when_do_i_pay_2") {
    //     setPayTime("Pay After Session");
    //     info.whereDoIPay = 2;
    //   } else {
    //     setPayTime("");
    //     info.whereDoIPay = "";
    //   }
    //   // if (checked) {
    //   //   info.whereDoIPay.push(value);
    //   //   display.whereDoIPay.push(name);
    //   // } else {
    //   //   removeValue(info.whereDoIPay, value);
    //   //   removeValue(display.whereDoIPay, name);
    //   // }
    // }
    if (type === "wheredoipay") {
      updatewhereDoIPay(value, checked);
      if (checked) {
        info.whereDoIPay.push(value);
        display.whereDoIPay.push(name);
      } else {
        removeValue(info.whereDoIPay, value);
        removeValue(display.whereDoIPay, name);
      }
    }

    if (type === "sessionlength") {
      updateSessionLength(value, checked);
      maxNoOfParticipantList.map((item) => {
        updateMaxNoOfParticipant(item.id, false);
      });

      if (checked) {
        info.sessionLength = [];
        let itesm = [];
        sessionLengthList.map((item) => {
          if (item.status) {
            itesm.push(item.id);
          }
        });
        itesm.map((val) => {
          info.sessionLength.push(val);
        });
        // display.sessionLength.push(name);
      } else {
        removeValue(info.sessionLength, parseInt(value));
        removeValue(display.sessionLength, name);
      }
    }
    if (type === "experience") {
      updateExperience(value, checked);
      if (checked) {
        info.experience.push(value);
        display.experience.push(name);
      } else {
        removeValue(info.experience, value);
        removeValue(display.experience, name);
      }
    }
    filterTimerRef.current = setTimeout(() => runFilter(info), 500);
    setDisplayData(display);
    setFilterData(info);
  };





  useEffect(() => {
    let states = checkWindowSize() > 767 ? true : false;

    setFilterTab(states);
  }, []);
  useEffect(() => {
    // window.loadModal2('#Prepaypostpaycheck', 'show');

    let items = languages.map((item) => {
      return {
        ...item,
        status: false,
        type: "languages",
      };
    });
    setlanguagesList(items);
  }, ["", languages]);
  useEffect(() => {
    let items = specialtyData.map((item) => {
      return {
        ...item,
        status: false,
        type: "specialty",
      };
    });
    setspecialtyList(items);
  }, ["", specialtyData]);
  const removeValue = (array, value) => {
    const index = array.indexOf(value);
    if (index > -1) {
      array.splice(index, 1);
    }
    return array;
  };
  // Remember where the client was in the list so Back lands them there again;
  // the booking flow itself is shared with the favourites page.
  const bookFromList = (info) => {
    localStorage.setItem("offset", offset);
    getBookingLink(info);
  };

  const startSeesionNew = (info) => {
    let inf = {
      general: {
        ...info,
        personal_booking_link: info.personal_booking_link,
        payType: info.payType,
        pre_pay_session_type: info.pre_pay_session_type,
        post_pay_session_type: info.post_pay_session_type,
        medium_id: info.medium_id,

      },
    };
    console.log("inf", inf);
    setBookInfo(inf);
    {
      setRenderType("newappointment");
      // auth.user.terms_session_status === 1
      //   ? startBookaSessionLaterQuestions()
      //   : startBookaSessionLaterVideo();
    }
  };
  const checkPostPreType = (info) => {
    let status = false;
    const {
      payType,
      post_pay_schedule,
      pre_pay_schedule,
      is_paypal_integrated,
      is_stripe_integrated,
    } = info;

    if (!is_paypal_integrated && !is_stripe_integrated) {
      toast.error(t("listing.noAvailability"), {
        position: "top-center",
      });
      return;
    } else if (is_paypal_integrated && is_stripe_integrated) {
      dispatch(setPaymentMethodAvailbale("both"));
    } else if (is_paypal_integrated && !is_stripe_integrated) {
      dispatch(setPaymentMethodAvailbale("paypal"));
    } else if (!is_paypal_integrated && is_stripe_integrated) {
      dispatch(setPaymentMethodAvailbale("stripe"));
    }

    if (payType.length === 2) {
      if (!post_pay_schedule && !pre_pay_schedule) {
        // setPaytypeText('both post pay pre pay avialable for this medium')
        toast.error(t("listing.noAvailability"), {
          position: "top-center",
        });
        return;
      }
      if (post_pay_schedule && pre_pay_schedule) {
        // window.loadModal2("#Prepaypostpaycheck", "show");
        // setPaytypeText('both post pay pre pay avialable for this medium')
        // toast.success('both post pay pre pay avialable for this medium', { position: 'top-center' })
        // status = true
      } else if (post_pay_schedule && !pre_pay_schedule) {
        // window.loadModal2("#Prepaypostpaycheck", "show");
        // setPaytypeText('Only post pay avialable for this medium')
        dispatch(setPaymentTypeAvailbale("Pay After Session"));
        // status = true;
        // toast.error('Only post pay avialable for this medium', { position: 'top-center' })
      } else if (!post_pay_schedule && pre_pay_schedule) {
        // window.loadModal2("#Prepaypostpaycheck", "show");
        dispatch(setPaymentTypeAvailbale("Pay Before Session"));

        // status = true;
        // setPaytypeText('Only pre pay avialable for this medium')
        // toast.error('Only pre pay avialable for this medium', { position: 'top-center' })
      }

      // else if (post_pay_schedule || pre_pay_schedule) {
      //   status = true
      // }
      else {
        // setPaytypeText('No schedule available for this medium')
        toast.error(t("listing.noSchedule"), {
          position: "top-center",
        });
      }
    } else {
      if (payType[0] === 1 && pre_pay_schedule) {
        dispatch(setPaymentTypeAvailbale("Pay Before Session"));
        // getSubsessions(8);
        // setPaytypeText('only pre pay added and available')
        // toast.success('only pre pay added and available', { position: 'top-center' })
        status = true;
      }
      // else if (payType[0] === 1 && !pre_pay_schedule) {
      //   setPaytypeText('No pre pay schedule available for this medium')
      //   toast.error('No pre pay schedule available for this medium', { position: 'top-center' })
      // }
      else if (payType[0] === 2 && post_pay_schedule) {
        dispatch(setPaymentTypeAvailbale("Pay After Session"));
        // getSubsessions(7);
        // setPaytypeText('only post pay added and available')
        // toast.success('only post pay added and available', { position: 'top-center' })
        status = true;
      }
      // else if (payType[0] === 2 && !post_pay_schedule) {
      //   setPaytypeText('No post pay schedule available for this medium')
      //   toast.error('No post pay schedule available for this medium', { position: 'top-center' })
      // }
      else {
        // setPaytypeText('No schedule available for this medium')
        toast.error(t("listing.noAvailability"), {
          position: "top-center",
        });
      }
    }
    return status;
  };
  // const filterListMediums = (constants) => {
  //   const { email, screen_name, created_at, orderBy = "asc" } = constants;
  //   let body = {
  //     email,
  //     screen_name,
  //     created_at,
  //     orderBy,
  //   };

  //     filterAllmediums(body)
  //       .then((data) => {
  //         if (data.data.status) {
  //           dispatch(setAllMediums(data.data.data.data));
  //           setbackupMediums(JSON.parse(JSON.stringify(data.data.data.data)));
  //         }
  //       })
  //       .catch(() => {});

  // };

  const checkWindowSize = () => {
    return window.innerWidth;
  };
  const clickViewProfile = (item) => {
    localStorage.setItem("offset", offset);
    onClick(item.id);
  };
  const backbtnHandler = () => {
    localStorage.removeItem("offset");
    back();
  };
  const scrollControllerHandler = () => {
    window.scrollTo({ top: offset + 200, left: 0, behavior: "smooth" });
  };
  const checkSessionExtraPersion = (item) => {
    const obj = JSON.parse(item.session_length);

    const sessionKeys = Object.keys(obj);
    const isOffered = sessionKeys.includes("452") || sessionKeys.includes("602");
    if (isOffered) {
      return "";
    } else {
      return <em>{t("card.notOffered")}</em>;
    }
  }
  const checkSessionFoutyFiveExtraPersion = (item) => {
    if (Array.isArray(item.offerings)) {
      const offering = item.offerings.find((o) => o.key === "452");
      if (!offering) {
        return <em>{t("card.notOffered")}</em>;
      }
      let delta = offering.extra_person_delta;
      if (delta === null || delta === undefined || delta === "") {
        delta =
          offering.base_price !== null && offering.base_price !== undefined && offering.base_price !== ""
            ? parseFloat(offering.price) - parseFloat(offering.base_price)
            : offering.price;
      }
      return "$ " + delta + " " + offering.currency;
    }

    // Fallback for API responses without the `offerings` array yet
    const session_currency_obj = JSON.parse(item.session_currency);
    const obj = JSON.parse(item.session_length);
    const sessionCurrencyKeys = Object.keys(session_currency_obj);
    const sessionKeys = Object.keys(obj);
    const isOffered = sessionKeys.includes("452");
    const sessionCurrency = sessionCurrencyKeys.includes("452");
    let currency = "USD";
    if (sessionCurrency) {
      currency = session_currency_obj[452];
    }
    if (isOffered) {
      return "$ " + obj[452] + " " + currency;
    } else {
      return <em>{t("card.notOffered")}</em>;
    }
  }
  const checkSessionSixtyExtraPersion = (item) => {
    if (Array.isArray(item.offerings)) {
      const offering = item.offerings.find((o) => o.key === "602");
      if (!offering) {
        return <em>{t("card.notOffered")}</em>;
      }
      let delta = offering.extra_person_delta;
      if (delta === null || delta === undefined || delta === "") {
        delta =
          offering.base_price !== null && offering.base_price !== undefined && offering.base_price !== ""
            ? parseFloat(offering.price) - parseFloat(offering.base_price)
            : offering.price;
      }
      return "$ " + delta + " " + offering.currency;
    }

    // Fallback for API responses without the `offerings` array yet
    const session_currency_obj = JSON.parse(item.session_currency);
    const obj = JSON.parse(item.session_length);
    const sessionCurrencyKeys = Object.keys(session_currency_obj);
    const sessionKeys = Object.keys(obj);
    const isOffered = sessionKeys.includes("602");
    const sessionCurrency = sessionCurrencyKeys.includes("602");
    let currency = "USD";
    if (sessionCurrency) {
      currency = session_currency_obj[602];
    }
    if (isOffered) {
      return "$ " + obj[602] + " " + currency;
    } else {
      return <em>{t("card.notOffered")}</em>;
    }
  }

  const checkSessionOffered = (item) => {

    if (item.session_length !== "" && item.length !== undefined) {
      if (
        ((JSON.parse(item.session_length))[4] === undefined ||
          Object.values(JSON.parse(item.session_length))[4] === "") &&
        ((JSON.parse(item.session_length))[3] === "" ||
          Object.values(JSON.parse(item.session_length))[3] === undefined)
      ) {
        return <em>{t("card.notOffered")}</em>;
      }
      // (Object.values(
      //   JSON.parse(item.session_length)
      // )[4] === "" ||
      //   Object.values(
      //     JSON.parse(item.session_length)
      //   )[4] === undefined) &&
      // (Object.values(
      //   JSON.parse(item.session_length)
      // )[3] === "" || Object.values(
      //   JSON.parse(item.session_length)
      // )[3] === undefined) && (
      //   <em>Not Offered</em>
      // )
    } else {
      return <em>{t("card.notOffered")}</em>;
    }
  };
  const checkItemFortyFive = (item) => {
    if (item.session_length !== "" && item.session_length !== undefined) {
      if (
        Object.values(JSON.parse(item.session_length))[3] === "" ||
        Object.values(JSON.parse(item.session_length))[3] === undefined
      ) {
        return true;
      }
    } else {
      return true;
    }
  };
  const fourtyFive = (item) => {
    if (item.session_length !== "" && item.session_length !== undefined) {
      if (
        Object.values(JSON.parse(item.session_length))[3] === "" ||
        Object.values(JSON.parse(item.session_length))[3] === undefined
      ) {
        return true;
      }
    } else {
      return true;
    }
  };
  const checkItemSixty = (item) => {
    if (item.session_length !== "" && item.session_length !== undefined) {
      if (
        Object.values(JSON.parse(item.session_length))[4] === "" ||
        Object.values(JSON.parse(item.session_length))[4] === undefined
      ) {
        return true;
      }
    } else {
      return true;
    }
  };
  checkWindowSize() < 767 && useOutsideAlerter(wrapperRef, setFilterTab);


    useEffect(() => {
    const params = new URLSearchParams(location.search);
    const from = params.get("from");
    const mediumId = params.get("selectedMediumId");

    if (from === "coach-reviews") {
        console.log("MATCHED MEDIUM DATA");
        let infodetaiol = JSON.parse(sessionStorage.getItem("userDataInfo"));
        setProfessionalInfo(infodetaiol);
        getMediumServiceDetails(infodetaiol.medium_id)
          .then((data) => {
            if (data.data.status) {
              setMediumSessionInfo(data.data.data[0]);
              let singleVal = data.data.data[0];
                  const sessionType = singleVal.type;
                  const info  = singleVal.info;

                  // Honor the duration/price the client actually picked in the
                  // Favorite Mediums popup (infodetaiol.subsession_id) instead of
                  // always re-booking the medium's first listed session option.
                  // Only fall back to the first option if that exact one is no
                  // longer offered.
                  const matchedInfo = info.find(
                    (item) => String(item.subsession_id) === String(infodetaiol.subsession_id)
                  ) || info[0];

                  const durationValue = matchedInfo.subsession_id;
                  const durationVal = matchedInfo.forTwo != 0 ? matchedInfo.duration+"2" : matchedInfo.duration;
                  const amountVal = matchedInfo.price;
                  const currencyVal = matchedInfo.currency;

                  let updatedPayment = {
                    ...infodetaiol,
                    subsession_id: matchedInfo.subsession_id,
                    payStatus: sessionType === "Pay_Before" ? 'before' : 'after'
                  };

                  // ✅ Update State
                  //setProfessionalInfo(updatedPayment);


                  //startSeesion(paymen);

                  getSubsessions(info, durationValue, durationVal ,amountVal,currencyVal)
                  console.log(info,durationValue,durationVal,amountVal,currencyVal,"value");
                  // ✅ Now Call the Function
                  startSeesionNew(updatedPayment);
            }
          })
          .catch(() => { });

    }
  }, [location.search, practitioners]);
  return (
    <>
      <div
        className={`schedule-advance-box-all  ${checkWindowSize() < 767 ? "" : "schedule-advance-box-all-container schedule-advance-box-all-container-professional"
          }`}
      >
        <div className="appointment-select-tab-btn-wrapper p-2">
          <div className="row">
            <div className="col-lg-3 col-md-5">
              <div class="back-btn-profile mb-2">
                <div onClick={backbtnHandler} className="bac-href pointer">
                  <img className="bac-img" src="images/arrow-back.png" alt="back" />
                  {t("listing.goBack")}
                </div>
                <div
                    onClick={() => {
                      setFilterTab(!filterTab);
                    }}
                    className="text-center filter-image filter-image-align"
                  >
                    <img className="cross-icon-image" src="localImages/filter.png" />
                    {t("listing.filter")}
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-md-7">
              <h3 className="text-center m-top-12 new-line-left">
                {t("listing.heading")}
              </h3>
              <p className="font-size-18 ml-2 mr-2 text-center spaced-paragraph new-line-para">
                {t("listing.intro")}
              </p>

            </div>

          </div>

        </div>
        <div className="row">
          <div className="col-lg-3 col-md-5"></div>
          <div className="col-lg-9 col-md-7">
           <div className="verified-box verified-box-top">
      <h2
  className="hoverHeading pointer"
  onClick={() => setOpen(!open)}
  style={{
    cursor: "pointer",
    display: "flex",
    justifyContent: "center", // keeps VERIFIED centered
    alignItems: "center",
    position: "relative", // allows absolute positioning
  }}
>
  <span className="hoverBadge">{t("verified.badge")}</span>
  <span
    style={{
      fontSize: "20px",
      position: "absolute",
      right: "15px", // adjust spacing from right edge
      top: "50%",
      transform: "translateY(-50%)", // vertically centers the icon
    }}
  >
    {open ? "−" : "+"}
  </span>
</h2>

      {open && (
        <p className="verified-para-top">
          <Trans
            i18nKey="verified.listDescription"
            ns="clientPremium"
            components={{
              a: (
                <a
                  href="https://verified.verysoul.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
        </p>
      )}
    </div>

              </div>
        </div>
        <div className="row unset-flex-wrap">
          <div className="col-lg-3 col-md-5 filter-box-professional">
            <div
              ref={wrapperRef}
              className={`schedule-advance-box-left filter-box-professional-inner d-block ${filterTab ? "" : "d-none"
                }`}
            >
              {checkWindowSize() < 767 && (
                <div className="cross-icon-image">
                  <img
                    onClick={() => {
                      setFilterTab(false);
                    }}
                    src="localImages/crossicon.png"
                  />
                </div>
              )}
              <h3>{t("listing.filter")}</h3>
              <div class="accordion" id="accordionExample">
                <div class="item">
                  <div className="search-box search-container">
                    <input
                      value={selectedName}
                      onChange={(e) => changeHandler(e, "name")}
                      className="search-input"
                      type="text"
                      placeholder={t("listing.searchByName")}
                    />
                  </div>
                </div>
                <div class="item">
                  <div class="item-header" id="headingOne">
                    <h2 class="mb-0">
                      <button
                        class="btn btn-link"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <img
                          className="langu-img"
                          src="images/Language.png"
                          alt="#"
                        />{" "}
                        {t("listing.filters.language")}
                        <img src="images/dropdown.png" alt="caret-down"></img>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordionExample"
                  >
                    <div class="t-p">
                      <div className="slect-language-list">
                        {languagesList.map((item) => (
                          <div class="form-group">
                            <input
                              onChange={(e) => changeHandler(e, "language")}
                              checked={item.status}
                              type="checkbox"
                              value={item.id}
                              name={item.name}
                              id={item.name}
                            />
                            <label htmlFor={item.name}>{item.name}</label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/*************************************************************************************************** */}
                <div class="item">
                  <div class="item-header" id="headingNine">
                    <h2 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseNine"
                        aria-expanded="false"
                        aria-controls="collapseNine"
                      >
                         <img
                          className="langu-img filter-images-n"
                          src="localImages/calendara.png"
                          alt="#"
                        />{" "}
                        {t("listing.filters.availability")}
                        <img src="images/dropdown.png" alt="caret-down"></img>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseNine"
                    class="collapse"
                    aria-labelledby="headingNine"
                    data-parent="#accordionExample"
                  >
                    <div class="t-p">
                      <div className="slect-language-list">
                        <div class="form-group">
                          <input
                            checked={availability === "Today" ? true : false}
                            type="checkbox"
                            id={"Today"}
                            value={"today"}
                            name={"Today"}
                            onChange={(e) => changeHandler(e, "Availability")}
                          />
                          <label htmlFor="Today">{t("listing.availabilityOptions.today")}</label>
                        </div>
                        <div class="form-group">
                          <input
                            checked={availability === "Tomorrow" ? true : false}
                            type="checkbox"
                            id="Tomorrow"
                            name="Tomorrow"
                            value={"tomorrow"}
                            onChange={(e) => changeHandler(e, "Availability")}
                          />
                          <label htmlFor="Tomorrow">{t("listing.availabilityOptions.tomorrow")}</label>
                        </div>
                        <div class="form-group">
                          <input
                            checked={availability === "This Week" ? true : false}
                            type="checkbox"
                            id="ThisWeek"
                            name="This Week"
                            value={"this_week"}
                            onChange={(e) => changeHandler(e, "Availability")}
                          />
                          <label htmlFor="ThisWeek">{t("listing.availabilityOptions.thisWeek")}</label>
                        </div>
                        <div class="form-group">
                          <input
                            checked={availability === "Any" ? true : false}
                            type="checkbox"
                            id="Any"
                            name="Any"
                            value={"Any"}
                            onChange={(e) => changeHandler(e, "Availability")}
                          />
                          <label htmlFor="Any">{t("listing.availabilityOptions.any")}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/************************************************ */ }

                 <div class="item">
                  <div class="item-header" id="headingSix">
                    <h2 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        <img
                          className="langu-img filter-images-new"
                          src="localImages/quality.png"
                          alt="#"
                       
                        />{" "}
                        {t("listing.filters.yearsAsProfessional")}
                        <img src="images/dropdown.png" alt="caret-down"></img>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseSix"
                    class="collapse"
                    aria-labelledby="headingSix"
                    data-parent="#accordionExample"
                  >
                    <div class="t-p">
                      <div className="slect-language-list">
                        {experienceList.map((item) => (
                          <div class="form-group">
                            <input
                              onChange={(e) => changeHandler(e, "experience")}
                              checked={item.status}
                              type="checkbox"
                              value={item.id}
                              name={item.name}
                              id={item.name}
                            />
                            <label htmlFor={item.name}>
                              {t(`listing.experienceOptions.${item.name}`, { defaultValue: item.label })}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/*************************************************************************************************** */}
                <div class="item">
                  <div class="item-header" id="headingEight">
                    <h2 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseEight"
                        aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        <img
                          className="langu-img filter-images-n"
                          src="localImages/usera.png"
                          alt="#"
                        />{" "}
                        {t("listing.filters.maxParticipants")}
                        <img src="images/dropdown.png" alt="caret-down"></img>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseEight"
                    class="collapse"
                    aria-labelledby="headingEight"
                    data-parent="#accordionExample"
                  >
                    <div class="t-p">
                      <div className="slect-language-list">
                        {maxNoOfParticipantList.map((item) => (
                          <div class="form-group">
                            <input
                              onChange={(e) =>
                                changeHandler(e, "maxNoOfParticipant")
                              }
                              checked={item.status}
                              type="checkbox"
                              value={item.id}
                              name={item.name}
                              id={item.name}
                            />
                            <label htmlFor={item.name}>{item.label}</label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/******************************************************************************************* */}

                <div class="item">
                  <div class="item-header" id="headingSeven">
                    <h2 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseSeven"
                        aria-expanded="true"
                        aria-controls="collapseSeven"
                      >
                        <img
                          className="langu-img filter-images-n"
                          src="localImages/dollara.png"
                          alt="#"
                        />{" "}
                        {t("listing.filters.currency")}
                        <img src="images/dropdown.png" alt="caret-down"></img>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseSeven"
                    class="collapse"
                    aria-labelledby="headingSeven"
                    data-parent="#accordionExample"
                  >
                    <div class="t-p">
                      <div className="slect-language-list">
                        {/* <div class="form-group">
                            <input
                              checked={recording === "Yes" ? true : false}
                              type="checkbox"
                              id={"Yes"}
                              value={1}
                              name={"Yes"}
                              onChange={(e) => changeHandler(e, "Recording")}
                            />
                            <label htmlFor="Yes">Yes</label>
                          </div>
                          <div class="form-group">
                            <input
                              checked={recording === "No" ? true : false}
                              type="checkbox"
                              id="No"
                              name="No"
                              value={0}
                              onChange={(e) => changeHandler(e, "Recording")}
                            />
                            <label htmlFor="No">No</label>
                          </div> */}
                        {currencyList.map((item) => (
                          <div class="form-group">
                            <input
                              onChange={(e) => changeHandler(e, "currency")}
                              checked={item.name === currencyName}
                              type="checkbox"
                              value={item.id}
                              name={item.name}
                              id={item.name}
                            />
                            <label htmlFor={item.name}>{item.name}</label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {/****************************************************************************************** */}

                <div class="item">
                  <div class="item-header" id="headingFour">
                    <h2 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        <img
                          className="langu-img"
                          src="images/fluent_payment-48-filled.png"
                          alt="#"
                        />
                        {t("listing.filters.scheduleOfPayment")}
                        <img src="images/dropdown.png" alt="caret-down"></img>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseFour"
                    class="collapse"
                    aria-labelledby="headingFour"
                    data-parent="#accordionExample"
                  >
                    <div class="t-p">
                      <div className="slect-language-list">
                        {whereDoIPayList.map((item) => (
                          <div class="form-group">
                            <input
                              onChange={(e) => changeHandler(e, "wheredoipay")}
                              checked={item.status}
                              type="checkbox"
                              value={item.id}
                              name={item.name}
                              id={item.name}
                            />
                            <label htmlFor={item.name}>
                              {t(`listing.payScheduleOptions.${item.name}`, { defaultValue: item.label })}
                            </label>
                          </div>
                        ))}
                        {/* <div class="form-group">
                          <input
                            checked={paytime === "Pay to Book" ? true : false}
                            type="checkbox"
                            name="when_do_i_pay_1"
                            id="when_do_i_pay_1"
                            value={1}
                            onChange={(e) => changeHandler(e, "wheredoipay")}
                          />
                          <label htmlFor="when_do_i_pay_1">Pay to Book</label>
                        </div>
                        <div class="form-group">
                          <input
                            type="checkbox"
                            checked={
                              paytime === "Pay After Session" ? true : false
                            }
                            name="when_do_i_pay_2"
                            id="when_do_i_pay_2"
                            value={2}
                            onChange={(e) => changeHandler(e, "wheredoipay")}
                          />
                          <label htmlFor="when_do_i_pay_2">
                            Pay After Session
                          </label>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item">
                  {/* <div class="item-header" id="headingTwo">
                    <h2 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        Specialties
                        <img src="images/dropdown.png" alt="caret-down"></img>
                      </button>
                    </h2>
                  </div> */}
                  {/* <div
                    id="collapseTwo"
                    class="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#accordionExample"
                  >
                    <div class="t-p">
                      <div className="slect-language-list">
                        {specialtyList.map((item) => <div class="form-group">
                          <input type="checkbox" onChange={(e) => changeHandler(e, 'specialty')} checked={item.status} id={item.specialty_name} value={item.id} name={item.specialty_name} />
                          <label htmlFor={item.specialty_name}>{item.specialty_name}</label>
                        </div>)}

                      </div>
                    </div>
                  </div> */}
                </div>
                <div class="item">
                  <div class="item-header" id="headingFive">
                    <h2 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        <img
                          className="langu-img"
                          src="images/clock11.png"
                          alt="#"
                        />{" "}
                        {t("listing.filters.sessionLength")}
                        <img src="images/dropdown.png" alt="caret-down"></img>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseFive"
                    class="collapse"
                    aria-labelledby="headingFive"
                    data-parent="#accordionExample"
                  >
                    <div class="t-p">
                      <div className="slect-language-list">
                        {sessionLengthList.map((item) => (
                          <div class="form-group">
                            <input
                              onChange={(e) =>
                                changeHandler(e, "sessionlength")
                              }
                              checked={item.status}
                              type="checkbox"
                              value={item.id}
                              name={item.name}
                              id={item.name}
                            />
                            <label htmlFor={item.name}>
                              {t(`listing.sessionLengthOptions.${item.name}`, { defaultValue: item.label })}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

               
                
                {/************************* Favorites ************************** */}
                {canFavorite && (
                  <div class="item">
                    <div class="item-header" id="headingFavorites">
                      <h2 class="mb-0">
                        <button
                          class="btn btn-link collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseFavorites"
                          aria-expanded="false"
                          aria-controls="collapseFavorites"
                        >
                          <img
                            className="langu-img filter-images-n"
                            src="/AllNewIcons/Color/heart.png"
                            alt="#"
                          />{" "}
                          {t("listing.filters.favorites")}
                          <img src="images/dropdown.png" alt="caret-down"></img>
                        </button>
                      </h2>
                    </div>
                    <div
                      id="collapseFavorites"
                      class="collapse"
                      aria-labelledby="headingFavorites"
                      data-parent="#accordionExample"
                    >
                      <div class="t-p">
                        <div className="slect-language-list favorites-filter-list">
                          <div class="form-group">
                            <input
                              checked={favoritesOnly}
                              type="checkbox"
                              id="OnlyMyFavorites"
                              name="Only my favorites"
                              value={1}
                              onChange={(e) => changeHandler(e, "Favorites")}
                            />
                            <label htmlFor="OnlyMyFavorites">
                              {t("listing.filters.onlyMyFavorites")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/*************************************************************************************************** */}
                <div class="item">
                  <div class="item-header" id="headingThree">
                    <h2 class="mb-0">
                      <button
                        class="btn btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <img
                          className="langu-img"
                          src="images/ph_video-camera-fill.png"
                          alt="#"
                        />
                        {t("listing.filters.recordingAvailability")}
                        <img src="images/dropdown.png" alt="caret-down"></img>
                      </button>
                    </h2>
                  </div>
                  <div
                    id="collapseThree"
                    class="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordionExample"
                  >
                    <div class="t-p">
                      <div className="slect-language-list">
                        <div class="form-group">
                          <input
                            checked={recording === "Yes" ? true : false}
                            type="checkbox"
                            id={"Yes"}
                            value={1}
                            name={"Yes"}
                            onChange={(e) => changeHandler(e, "Recording")}
                          />
                          <label htmlFor="Yes">{t("listing.recordingOptions.Yes")}</label>
                        </div>
                        <div class="form-group">
                          <input
                            checked={recording === "No" ? true : false}
                            type="checkbox"
                            id="No"
                            name="No"
                            value={0}
                            onChange={(e) => changeHandler(e, "Recording")}
                          />
                          <label htmlFor="No">{t("listing.recordingOptions.No")}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
              </div>

              <div className="filter-tabs-container">
                {/* {specialtyList.map((item) => item.status ? <span className="filter-tabs">{item.specialty_name}<span onClick={() => deleteElementdeleteElement(item, 'specialty')} className="pointer filter-tabs-cross">X</span></span> : '')} */}
                {languagesList.map((item) =>
                  item.status ? (
                    <span className="filter-tabs">
                      {item.name}
                      <span
                        onClick={() => deleteElement(item, "language")}
                        className="pointer filter-tabs-cross"
                      >
                        X
                      </span>
                    </span>
                  ) : (
                    ""
                  )
                )}
                {sessionLengthList.map((item) =>
                  item.status ? (
                    <span className="filter-tabs">
                      {t(`listing.sessionLengthOptions.${item.name}`, { defaultValue: item.label })}
                      <span
                        onClick={() => deleteElement(item, "sessionlength")}
                        className="pointer filter-tabs-cross"
                      >
                        X
                      </span>
                    </span>
                  ) : (
                    ""
                  )
                )}
                {maxNoOfParticipantList.map((item) =>
                  item.status ? (
                    <span className="filter-tabs">
                      {t("listing.maxParticipant", { value: item.label })}
                      <span
                        onClick={() => deleteElement(item, "currency")}
                        className="pointer filter-tabs-cross"
                      >
                        X
                      </span>
                    </span>
                  ) : (
                    ""
                  )
                )}
                {experienceList.map((item) =>
                  item.status ? (
                    <span className="filter-tabs">
                      {t(`listing.experienceOptions.${item.name}`, { defaultValue: item.label })}
                      <span
                        onClick={() => deleteElement(item, "experience")}
                        className="pointer filter-tabs-cross"
                      >
                        X
                      </span>
                    </span>
                  ) : (
                    ""
                  )
                )}
                {whereDoIPayList.map((item) =>
                  item.status ? (
                    <span className="filter-tabs">
                      {t(`listing.payScheduleOptions.${item.name}`, { defaultValue: item.label })}
                      <span
                        onClick={() => deleteElement(item, "wheredoipay")}
                        className="pointer filter-tabs-cross"
                      >
                        X
                      </span>
                    </span>
                  ) : (
                    ""
                  )
                )}
                {recording !== "" ? (
                  <span className="filter-tabs">
                    {t(`listing.recordingOptions.${recording}`, { defaultValue: recording })}
                    <span
                      onClick={() => {
                        deleteInfo("rec");
                        setRecording("");
                      }}
                      className="pointer filter-tabs-cross"
                    >
                      X
                    </span>
                  </span>
                ) : (
                  ""
                )}
                {availability !== "" ? (
                  <span className="filter-tabs">
                    {AVAILABILITY_KEYS[availability]
                      ? t(`listing.availabilityOptions.${AVAILABILITY_KEYS[availability]}`)
                      : availability}
                    <span
                      onClick={() => {
                        deleteInfo("avai");
                        setAvailability("");
                      }}
                      className="pointer filter-tabs-cross"
                    >
                      X
                    </span>
                  </span>
                ) : (
                  ""
                )}

                {favoritesOnly ? (
                  <span className="filter-tabs">
                    {t("listing.filters.onlyMyFavorites")}
                    <span
                      onClick={() => {
                        deleteInfo("fav");
                      }}
                      className="pointer filter-tabs-cross"
                    >
                      X
                    </span>
                  </span>
                ) : (
                  ""
                )}

                {currencyName !== "" ? (
                  <span className="filter-tabs">
                    {currencyName}
                    <span
                      onClick={() => {
                        deleteInfo("curren");
                        setCurrencyName("");
                      }}
                      className="pointer filter-tabs-cross"
                    >
                      X
                    </span>
                  </span>
                ) : (
                  ""
                )}
                {/* {paytime !== "" ? (
                  <span className="filter-tabs">
                    {paytime}
                    <span
                      onClick={() => {
                        deleteInfo();
                        setPayTime("");
                      }}
                      className="pointer filter-tabs-cross"
                    >
                      X
                    </span>
                  </span>
                ) : (
                  ""
                )} */}
              </div>
            </div>
            <div></div>
          </div>
          <div className="col-lg-9 col-md-7">
  <div className="schedule-advance-box-right">
    {isLoading || isListLoading ? (
      <div className="text-center py-5">
        <GridLoader size={50} color={"#D5A67B"} loading />
        <p className="mt-3">{t("listing.loadingProfessionalMediums")}</p>
      </div>
    ) : (
      <>
        <div className="d-flex-flex-wrap-wrap">
          {practitioners
            .filter(
              (item) =>
                !(
                  !item.show_flexbooker &&
                  item.session_length !== undefined &&
                  item.session_length === "[]"
                )
            )
            .map((item) => (
              <div className="col-md-12 mb-3 col-lg-4" key={item.medium_id}>
                <MediumCard
                  item={item}
                  onBookNow={bookFromList}
                  onViewProfile={clickViewProfile}
                  onToggleFavorite={onToggleFavorite}
                  canFavorite={canFavorite}
                  isTogglingFavorite={favoritePendingId === item.medium_id}
                  isOpeningProfile={
                    openingProfileId !== null &&
                    String(openingProfileId) === String(item.id)
                  }
                />
              </div>
          ))}
        </div>
        <div>
          <img
            src="localImages/arrow-189-xxl.png"
            onClick={scrollControllerHandler}
            className="svroll-arrow"
          />
        </div>
      </>
    )}
  </div>
</div>
           <div className="col-lg-3 col-md-5 verified-section">
            <div className="verified-box">
              <h2 className="hoverHeading">
                <span className="hoverBadge">{t("verified.badge")}</span>
              </h2>
              <br/>
              <p className="verified-para">
              <Trans
            i18nKey="verified.listDescription"
            ns="clientPremium"
            components={{
              a: (
                <a
                  href="https://verified.verysoul.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              ),
            }}
          />
              </p>
              </div>
            </div>
        </div>
      </div>

      {/* <div>
        <h4 className="practioner-heading">Practitioner</h4>
        <div className="starter-practioners">
          <div className="container">
            <div className="row box-practioners-internal">
              {practitioners.length &&

                practitioners.map((item) => (
                  <Practitoner item={item} onClick={onClick} />
                ))
              }

            </div>
          </div>
        </div>
        <div className="text-center">
          <Footer />
        </div>
      </div> */}
      {bookingModal}
    </>
  );
}
